export const I18n = {
  pluralize(count: number, variants: [string, string, string]) {
    const cases = [2, 0, 1, 1, 1, 2];
    return (
      count +
      " " +
      variants[
        count % 100 > 4 && count % 100 < 20
          ? 2
          : cases[count % 10 < 5 ? count % 10 : 5]
      ]
    );
  },
};
